export default {
  "b2b.zdroj-editace-form.field.nazevCs.label": "Name CS",
  "b2b.zdroj-editace-form.field.nazevEn.label": "Name EN",
  "b2b.zdroj-editace-form.field.popisCs.label": "Description CS",
  "b2b.zdroj-editace-form.field.popisEn.label": "Description EN",
  "b2b.zdroj-editace-form.field.exkluzivita.label": "Exclusive",
  "b2b.zdroj-editace-form.field.maxPocetPozadavku.label":
    "Maximum number of requests",
  "b2b.zdroj-editace-form.field.pozadavekSmena.label": "Shift required",
  "b2b.zdroj-editace-form.field.platnostOd.label": "Valid from",
  "b2b.zdroj-editace-form.button.delete": "Delete",
  "b2b.zdroj-editace-form.button.submit": "Save",
  "b2b.zdroj-editace-form.button.cancel": "Cancel",
  "b2b.zdroj-editace-widget.titleNew": "New resource",
  "b2b.zdroj-editace-form.save-dialog.title": "Save resource",
  "b2b.zdroj-editace-form.delete-dialog.title": "Delete resource"
};
